/**
 *
 * @param state
 * @returns {getSearchData}
 */
export const selectGetSearchData = (state) => state.getSearchData;

/**
 * Изменение поискового запроса
 * @param state
 */
export const selectSetSearchQuery = (state) => state.setSearchQuery;

/**
 *
 * @param state
 */
export const selectSetSearchType = (state) => state.setSearchType;

/**
 *
 * @param state
 */
export const selectSetSearchQueryOutput = (state) => state.setSearchQueryOutput;

/**
 * Обработка ввода данных
 * @param state
 */
export const selectOnChange = (state) => state.searchOnChange;

/**
 * Событие фокусировки инпута
 * @param state
 */
export const selectOnFocus = (state) => state.searchOnFocus;

/**
 * Событие потери фокуса у инпута
 * @param state
 */
export const selectOnBlur = (state) => state.searchOnBlur;
